import { getCard } from "../../content/lookups.js";
import type { PendingChoice, RunState } from "../../domain/types/index.js";

/**
 * 任意のカード選択で、対象があるのにまだ1枚も選ばれていないかを返す。
 * 必須選択（宿屋など）は確定ボタンを無効化しているため対象外。
 */
export function hasUnselectedOptionalTarget(run: RunState, pending: PendingChoice): boolean {
  const selectedCount =
    pending.kind === "meeting" ? Number(Boolean(pending.targetInstanceId))
      : pending.kind === "caseExclude" || pending.kind === "cellar" || pending.kind === "knowledgeShare"
        || pending.kind === "sendoff" || pending.kind === "workerCycle" || pending.kind === "stables" || pending.kind === "training" || pending.kind === "psychologicalCounseling" || pending.kind === "specialTaskTeam" ? pending.selected.length
        : null;
  if (selectedCount !== 0) return false;

  if (pending.kind === "cellar" || pending.kind === "caseExclude") return run.hand.length > 0;
  if (pending.kind === "knowledgeShare") return run.discard.length > 0;
  if (pending.kind === "sendoff" || pending.kind === "workerCycle" || pending.kind === "stables") {
    return run.hand.some((card) => getCard(card.cardId)?.type === "worker");
  }
  if (pending.kind === "training") {
    return run.hand.some((card) => card.cardId === "intern" || card.cardId === "mid");
  }
  if (pending.kind === "psychologicalCounseling") {
    return run.hand.some((card) => card.cardId === "idle" && !card.temporaryForCase);
  }
  if (pending.kind === "specialTaskTeam") {
    return run.hand.some((card) => card.cardId === "idle");
  }
  if (pending.kind === "meeting") {
    return run.hand.some((card) => getCard(card.cardId)?.type === "action");
  }
  return false;
}
